"use strict";
/**
 * Pending Dashboard Responses
 *
 * Aggregated view of pending items across the system. Visible to anyone.
 * Designed to grow over time — each card represents one source.
 */
Object.defineProperty(exports, "__esModule", { value: true });
